import { Button, FormControl, FormLabel, Input, Select } from '@chakra-ui/react';

import { AffiliateProviderRead } from '../../../gql/generated/graphql';

import Modal from '../../../components/shared/Modal';

type CreateApiKeyModalProps = {
  isOpen: boolean;
  onClose: () => void;
  affiliateName: string;
  setAffiliateName: (name: string) => void;
  selectedProviderId: string;
  setSelectedProviderId: (id: string) => void;
  handleCreateApiKey: () => Promise<void>;
  createLoading: boolean;
  providers: Array<AffiliateProviderRead | null | undefined>;
};

const CreateApiKeyModal = ({
  isOpen,
  onClose,
  affiliateName,
  setAffiliateName,
  selectedProviderId,
  setSelectedProviderId,
  handleCreateApiKey,
  createLoading,
  providers,
}: CreateApiKeyModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Create New API Key"
      rightButtons={
        <>
          <Button colorScheme="blue" mr={3} onClick={handleCreateApiKey} isLoading={createLoading}>
            Create
          </Button>
          <Button variant="ghost" onClick={onClose}>
            Cancel
          </Button>
        </>
      }
    >
      <FormControl mb={4}>
        <FormLabel>Affiliate API Key Name</FormLabel>
        <Input
          value={affiliateName}
          onChange={(e) => setAffiliateName(e.target.value)}
          placeholder="Enter affiliate api key name"
        />
      </FormControl>

      <FormControl>
        <FormLabel>Affiliate Provider</FormLabel>
        <Select
          placeholder="Select provider"
          value={selectedProviderId}
          onChange={(e) => setSelectedProviderId(e.target.value)}
        >
          {providers?.map((provider) => (
            <option key={provider?.id?.toString()} value={provider?.id?.toString()}>
              {provider?.name}
            </option>
          ))}
        </Select>
      </FormControl>
    </Modal>
  );
};

export default CreateApiKeyModal;
